import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {ATTRIBUTE_HISTROY_MINIMUM_LEVEL} from '../constants';

export const canViewAttributeHistory = () =>
	currentUserMeetsUserLevel(ATTRIBUTE_HISTROY_MINIMUM_LEVEL);
